import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import { SvgLolUggPlus } from "@ugitgud/legos/ui/icon/SVG/LolUggPlus";
import classNames from "classnames";

export const PREMIUM_BANNER_CTA = "premium-banner-cta";
interface PremiumBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function PremiumBanner(props: PremiumBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;
  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div
      className={classNames(
        "w-full h-[48px] bg-[#141D37] flex justify-start relative overflow-hidden border-b border-b-[#141D37]",
        className,
      )}
    >
      <img
        src="https://static.bigbrain.gg/assets/ugg/cta/premium-banner-zaahen.png"
        className="absolute max-w-none top-0 h-[48px] shrink-0 right-[-277px] min-[475px]:right-[-200px] sm:right-[-140px] md:right-[-56px] lg:right-[18px]"
      ></img>
      <div
        className={classNames(
          "absolute inset-0 z-10 flex items-center justify-center xxs:justify-start min-[700px]:justify-center gap-[22px] xs:gap-[34px] sm:gap-[42.5px] px-3 sm:px-6 md:px-8 text-white",
          { "pr-10": onClose },
        )}
      >
        <div className="flex items-center gap-3">
          <div className="flex flex-col">
            <div className="relative -top-0.5 uppercase text-[18px] leading-[18px] text-center xs:text-left whitespace-nowrap font-['Barlow_Condensed'] font-bold leading-normal flex items-center justify-center xs:justify-start gap-1">
              <span className="hidden xs:inline xs:text-[16px]">THE NEW U.GG</span>
              <Icon icon={<SvgLolUggPlus />} className="hidden xs:inline w-8 flex-shrink-0" />
              <span className="hidden xs:inline xs:text-[16px]">HAS ARRIVED</span>
              <span className="inline xs:hidden text-[16px]">THE NEW U.GG</span>
              <Icon icon={<SvgLolUggPlus />} className="inline xs:hidden w-8 flex-shrink-0" />
            </div>
            <div className="font-inter font-medium text-[12px] leading-[12px] hidden xs:block text-center sm:text-left">
              Display socials on your profile and other exclusive features.
            </div>
          </div>
        </div>
        <div
          className="bg-[#3273FA] hover:bg-[#2963DA] rounded-[3px] cursor-pointer p-2 sm:px-3 sm:py-2 flex items-center"
          onClick={onUrlClick}
        >
          <div className="text-[12px] sm:text-[13px] font-bold whitespace-nowrap">Discover U.GG Plus</div>
        </div>
      </div>

      {onClose && (
        <div
          className="absolute z-20 top-1/2 right-[12px] -translate-y-1/2 p-[6px] cursor-pointer hover:opacity-50"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="text-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)]" />
        </div>
      )}
    </div>
  );
}
